// /* eslint-disable prettier/prettier */
import Vue from 'vue';
import VueRouter, { Route, RouteConfig, NavigationGuardNext } from 'vue-router';
import Index from '@/views/index/Index.vue';
import BossReport from '@/views/boss/Report.vue';
import ShopReport from '@/views/shop/ShopReport.vue';
import policyRoutes from './policyRouter';
import AdRegistration from '@/views/splashscreen/AdRegistration.vue';
import login from '@/views/login/indexLogin.vue'
import shopRoutes from './shop';
import privateRoutes from '@/views/privacy/index.vue'
import CarDetail from '@/views/car/detaile.vue';
import mapIndex from '@/views/map/index.vue'

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  /** 首页 */
  {
    name: 'index',
    path: '/',
    component: Index,
    meta: {
      title: '德友惠mobile工作台',
    },
  },
  {
    name: 'login',
    path: '/login/:brandcode',
    component: login,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/report',
    component: BossReport,
    meta: {
      title: '统计数据报表',
    },
  },
  {
    name: 'shop_report',
    path: '/shop_report/:id',
    component: ShopReport,
    meta: {
      title: '门店报表',
    },
  },
  {
    name: 'car_detail',
    path: '/carDetail/:id',
    component: CarDetail,
    meta: {
      title: '车辆详情',
    },
  },
  {
    name: 'privateRoutes',
    path: '/private_routes/:code',
    component: privateRoutes,
    meta: {
      title: '手机隐私号实名认证',
    },
  },

  {
    name: 'map_index',
    path: '/map/index',
    component: mapIndex,
    meta: {
      title: '地图导航'
    }
  },
    {
    name: 'map_index',
    path: '/map/:poi/:time/:sign',
    component: mapIndex,
    meta: {
      title: '地图导航'
    }
  },

  /** 隐私政策、使用协议、托管服务协议、高德黑卡商户使用协议 */
  policyRoutes,
  ...shopRoutes,
  {
    name: 'ad_registration',
    path: '/splashscreen/ad-registration',
    component: AdRegistration,
    meta: {
      title: '广告通留资',
    },
  },
  /** 异常页面 */
  {
    name: 'exception',
    path: '/exception/:type',
    component: () => import('@/views/exception/Exception.vue'),
    meta: { title: '错误' },
  },
  {
    path: '*',
    name: 'notFount',
    component: () => import('@/views/exception/Exception.vue'),
    meta: {
      title: '该页面不存在',
    },
  },
];

/** 避免重复点击相同路由报错 */
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: string) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (originalPush.call(this, location) as unknown as Promise<any>).catch(
    (err) => err,
  );
};

const router = new VueRouter({
  routes,
});
// const whiteList = ['/login']; 
// const whiteNameList:any = ['login'];
const whiteList = ['/login', '/home', '/register'];
const whiteNameList = ['index', 'boss_report', 'shop_report', 'ad_registration', 'policy.blackcard', 'policy.privacy', 'exception', 'notFount', 'policy.protocol', 'policy.escrow', 'login', 'privateRoutes', 'car_detail', 'map_index'];

router.beforeEach(
  async (
    to: Route,
    from: Route,
    next: NavigationGuardNext<Vue>,
  ): Promise<void> => {
    /* 路由发生变化修改页面title */
    if (to.meta) {
      if (to.meta.title) {
        document.title = to.meta.title;
      }
    }
    if (whiteNameList.includes(to.name as string) || whiteList.includes(to.fullPath)) {
      next();
      return;
    }

    const userInfo = localStorage.getItem('user');
    if (!userInfo) {
      const url = `/login/${localStorage.getItem('brandcode') as string}`
      next({
        path: url
      });
      return;
    }


    const { token } = JSON.parse(userInfo);
    if (token) {
      next();
    } else {
      const url = `/login/${localStorage.getItem('brandcode') as string}`
      next({ path: url });
      return;
    }



    // next();
  }
);

export default router;
